import axios from 'axios';

export default {
  getAll(parameters = {}) {
    return axios.get('/interview-groups', { params: parameters });
  },
  create(body) {
    return axios.post('/interview-groups', body);
  },
  update(id, body) {
    return axios.patch(`/interview-groups/${id}`, body);
  },
  archive(id) {
    return axios.delete(`/interview-groups/${id}`);
  },
  restore(id) {
    return axios.post(`/interview-groups/${id}/restore`);
  },
  availableMembers(id, parameters = {}) {
    return axios.get(`/interview-groups/${id}/members/available`, {
      params: parameters,
    });
  },
  addMember(id, userId) {
    return axios.post(`/interview-groups/${id}/members`, { user_id: userId });
  },
  removeMember(id, userId) {
    return axios.delete(`/interview-groups/${id}/members/${userId}`);
  },
  addMapping(id, body) {
    return axios.post(`/interview-groups/${id}/mappings`, body);
  },
  updateMapping(id, mappingId, body) {
    return axios.patch(`/interview-groups/${id}/mappings/${mappingId}`, body);
  },
  removeMapping(id, mappingId) {
    return axios.delete(`/interview-groups/${id}/mappings/${mappingId}`);
  },
};
